import $ from "jquery";

import Backbone from "backbone";

import dateSelections from "./date_range_selector/date_selections";
import DateFormatter from "shared/formatters/dates";

import 'shared/jquery/datepicker';

import 'vendor/jquery/cookie';

import View from "backdraft-app/src/view";

import _ from "underscore";

import "jquery-deparam";

const customDatesTemplate = (wrapperClass = '', beforeContent = '') => `
      <div class="date-range-selector input-daterange ${wrapperClass}">
        ${beforeContent}
        <div class="input-group">
          <div class="input-group-addon input-sm">
            <i class="material-icons input-group-text">date_range</i>&nbsp;
          </div>
          <input type="text" class="input-sm form-control" name="start" readonly />
        </div>
        <div class="input-group input-daterange-separator">-</div>
        <div class="input-group">
          <div class="input-group-addon input-sm">
            <i class="material-icons input-group-text">date_range</i>&nbsp;
          </div>
          <input type="text" class="input-sm form-control" name="end" readonly />
        </div>
      </div>`;

export default class DateRangeSelector extends View {
  /* Date Range Selector
   options: defaultDateFilter (string) - defaults to "last_7days"
   */

  initialize(options = {}) {
    this.model = new Backbone.Model();
    this.defaultDateFilter = options.defaultDateFilter || 'last_7days';

    const dateHash = this._initParams();

    // Update date info
    this._changeDateFilter(dateHash);
  }

  // Use this to externally update the date pickers.
  // Contract for dateHash: { dates: ['from date', 'to date'], compareDates: ['compare_from date', 'compare_to date']}
  adjustDateRangeSelectorsFromResponse(dateHash) {
    this._mapDateRange(dateHash);
    this._replaceState();
    this.render();
  }

  _initParams() {
    const params = $.deparam(window.location.search.substring(1));
    const cookie = $.cookie("pegasus_reports_date_filter");
    let dateFilter;

    // Precedence rules for setting initial date values
    // 1. date_filter URL param
    // 2. pegasus_reports_date_filter cookie
    if (!_.isEmpty(params) && params.date_filter) {
      if (_.findWhere(dateSelections, { value: params.date_filter })) {
        dateFilter = params.date_filter;
      } else {
        dateFilter = this.defaultDateFilter;
      }
    } else if (cookie) {
      if (cookie.match(/^custom_/)) {
        dateFilter = this.defaultDateFilter;
      } else {
        dateFilter = cookie;
      }
    }

    return { dateFilter };
  }

  _changeDateFilter(dateHash) {
    const dateFilter = dateHash.dateFilter || this.defaultDateFilter;

    const range = DateFormatter.dateRange;
    const dates = _.map(range(dateFilter), this._dateString);
    this._setDates(_.extend({}, dateHash, { dateFilter, dates }));
  }

  _setDates(dateHash) {
    this.model.set(dateHash);

    // Publish the change and update URL params
    this._replaceState();
    this.trigger("change", dateHash.dateFilter, dateHash.dates, dateHash);
  }

  _getDateRange(dates, dateFilter) {
    if (dates) {
      return dates;
    } else {
      return _.map(DateFormatter.dateRange(dateFilter), this._dateString);
    }
  }

  render() {
    this.$el.html(_.template(this._buildTemplate()));
    this.$('.input-daterange').datepicker({
      format: DateFormatter.localeFormatString("datepicker"),
      orientation: "top",
      autoclose: true
    });
    this._drawControl();

    return this;
  }

  _getUpdatedUrlParams() {
    const url = window.location.href;
    const params = $.deparam(url.split("?")[1] || "");

    const nonDatePickerHash = {};
    _.each(params, (val, key) => {
      if (this._paramKeys().indexOf(key) === -1) {
        nonDatePickerHash[key] = val;
      }
    });

    return _.extend({}, nonDatePickerHash, this._getParams());
  }

  _paramKeys() {
    return ['to', 'from', 'date_filter'];
  }

  _getParams() {
    const dateFilter = this.model.get('dateFilter');

    const params = { date_filter: dateFilter };

    return params;
  }

  _replaceState() {
    const updatedUrlParams = this._getUpdatedUrlParams();
    const currentFragment = Backbone.history.fragment || "";
    Backbone.history.navigate(`${currentFragment.split("?")[0]}?${$.param(updatedUrlParams)}`, {
      trigger: false,
      replace: true
    });
  }

  _onDateFilterSelect(evt) {
    evt.preventDefault();
    const newValue = $(evt.currentTarget).data('value');
    this._changeDateFilter({ dateFilter: newValue });
    this._drawControl();
  }

  _drawControl() {
    const dateSelection = this._dateSelectionFromModel();
    const computedRange = DateFormatter.dateRange(dateSelection.value);

    this.$(".js-selected-value").html(dateSelection.label);
    this.$(".dropdown-menu").empty();

    const dateHash = {
      dates: computedRange,
      compareDates: computedRange
    };
    this._mapDateRange(dateHash);

    _.each(dateSelections, function({ value, label }) {
      const classes = value === this.model.get("dateFilter") ? 'active' : '';
      this.$(".dropdown-menu").append(`<a class="dropdown-item ${classes}" href="#" data-value="${value}">${label}</a>`);
    }, this);

    return this;
  }

  _dateSelectionFromModel() {
    const value = this.model.get("dateFilter");
    const selection = _.where(dateSelections, { value });

    if (selection.length === 0) {
      throw new Error(`dateFilter has invalid value not found in dateSelections array: ${value}`);
    }

    return selection[0];
  }

  _mapDateRange({ dates }) {
    if (dates && !_.isEmpty(_.compact(dates))) {
      this.model.set('dates', dates);
      this.$('.input-daterange:first > .input-group:first input').datepicker('update', dates[0]);
      this.$('.input-daterange:first > .input-group:last input').datepicker('update', dates[1]);
    } else {
      this.model.set('dates', false);
    }
    // link datepickers within date range
    this.$('.input-daterange').datepicker('updateDates');
  }

  _dateString(date) {
    return DateFormatter.fromDate(date, "date_only", true);
  }

  _buildTemplate() {
    return this.dropdownTemplate();
  }
}

_.extend(DateRangeSelector.prototype, {
  className: 'btn-group flex-centered-vertically',

  dropdownTemplate: _.template(`
        <div>
          <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            <span class="js-selected-value"></span> &nbsp;<span class="caret"></span>
          </button>
          <div class="dropdown-menu" role="menu">
          </div>
        </div>`),

  dateRangeSelectorTemplate: _.template(`<div>${customDatesTemplate("", '<div></div>')}</div>`),

  events: {
    "click .dropdown-menu .dropdown-item": "_onDateFilterSelect"
  }
});
